// Generated by Copilot
import { Colors } from "@blueprintjs/core";

import { Box, Flex } from "@/components/layout/flexbox";
import { buildComponentMetadata } from "@/components/pages_logged_in/program/components/componentMetadata";
import {
  getCloseDate,
  getDuration,
  isCloseEarlyComponent,
} from "@/components/pages_logged_in/program/components/utils";
import { DateTimeDisplay } from "@/components/pieces/DateTimeDisplay";
import { SUBTEXT_COLOR } from "@/css/constants";
import { ComponentTypeEnum } from "@/graphql";
import { MainComponent } from "@/types/programs";

interface ProgramComponentDateInfoProps {
  component: MainComponent;
  isProgramLead?: boolean;
}

export function ProgramComponentDateInfo({
  component,
  isProgramLead = false,
}: ProgramComponentDateInfoProps) {
  const { targetDueDate, targetStartDate, type } = component || {};
  const isGroupMeeting = type === ComponentTypeEnum.GroupMeeting;

  const dueDate = targetDueDate;
  const startDate = targetStartDate;
  const isCloseEarly = isCloseEarlyComponent(component);
  const metaData = buildComponentMetadata({
    component,
    isProgramLead,
  });

  const data = isGroupMeeting
    ? [
        {
          label: "Launch Date",
          value: startDate,
        },
      ]
    : [
        {
          label: "Launch Date",
          value: startDate,
        },
        {
          label: "Due Date",
          value: dueDate,
        },
        {
          label: "Close Date",
          value: getCloseDate(component),
        },
      ];

  if (
    metaData.isAnnouncement ||
    metaData.isOneOneMaster ||
    metaData.isGroupMeeting
  ) {
    data.splice(1, 1);
  }

  return (
    <Box flex={1} css={{ background: Colors.WHITE }}>
      <Flex flex={1} flexDirection={["column", "row"]}>
        {data.map((item) => (
          <Box
            key={item.label}
            mr={"16px"}
            justifyContent={"center"}
            mt={[2, 0]}
          >
            <Box color={SUBTEXT_COLOR} mb={[0, 2]}>
              {item.label}
            </Box>
            <Flex alignItems={"center"}>
              <Box fontSize={16}>
                <DateTimeDisplay
                  time={item.value}
                  formatString={
                    !isGroupMeeting ? "MMM d, yyyy" : "MMM d, yyyy h:mm a"
                  }
                  showDuration={isGroupMeeting}
                  duration={getDuration(component)}
                />
                {isCloseEarly && item.label.toUpperCase() === "CLOSE DATE" && (
                  <Box display={"inline-block"} ml={1}>
                    (ended early)
                  </Box>
                )}
              </Box>
            </Flex>
          </Box>
        ))}
      </Flex>
    </Box>
  );
}
